import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import { withRouter } from 'react-router-dom';
import { EAA_Item, EAA_ItemContainer, EAA_Input, EAA_ErrorText, EAA_Row, EAA_TitleText, EAA_Select, EAA_Btn } from '~/components/EditAndAddItem';
import { rightColor, leftColor } from '~/components/EditAndAddItem/common';
import PageTitle from '~/components/PageTitle';
import EditRes from '~/components/Dialog/EditRes';
import { re_email, re_psd } from '~/skills/TextRules';

class Page_PersonalManagement extends Component {
  state={
    oneselfData: {},
    old_oneselfData: {},
    mode: '',
    canSend: true,
    errorAry: [],
  }

  componentDidMount () {
    this.props.getOrgList();
    this.props.getGroupList();
    this.refresh();
  }

  componentDidUpdate (preProps) {
    const { oneself: preOneself = {} } = preProps;
    const { oneself = {} } = this.props;
    if (Object.keys(preOneself).length === 0 && Object.keys(oneself).length > 0) {
      this.setState({ oneselfData: oneself, old_oneselfData: oneself });
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('Oneself');
    // this.props.clearOneself();
  }

  refresh=() => this.props.getOneself();

  changeData=({ label = '', data = '' }) => {
    const { oneselfData: body } = this.state;
    const oneselfData = JSON.parse(JSON.stringify(body));
    oneselfData[label] = data;
    this.setState({ oneselfData });
  }

  send=() => {
    this.setState({ canSend: false });
    const { putOneSelf, putUserCheck } = this.props;
    const { oneselfData } = this.state;
    // console.log('oneselfData', oneselfData);
    const isActChecking = oneselfData.user_check_log_id && oneselfData.user_check_log_id.length > 0;
    const body = {
      // account: oneselfData.account,
      email: oneselfData.email,
      name: oneselfData.user_name,
      group_id: oneselfData.group_id,
      // memo: oneselfData.memo || '',
      mobile_number: oneselfData.mobile_number || '',
      org_id: oneselfData.org_id,
      tel_number: oneselfData.tel_number,
    };
    if ((oneselfData.old_passwd || '').length > 0) {
      body.old_passwd = oneselfData.old_passwd;
      body.passwd = oneselfData.passwd;
    }
    if (isActChecking)putUserCheck({ body, id: oneselfData.user_check_log_id });
    else putOneSelf(body);
  }

  goBack=() => this.props.history.push('/Main')
  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] })

  filterError=() => {
    const { oneselfData = {} } = this.state;
    const editPsd = ((oneselfData.old_passwd || '').length > 0) || ((oneselfData.passwd || '').length > 0) || ((oneselfData.passwd2 || '').length > 0);
    const errorAry = [
      (oneselfData.user_name || '').length === 0, // 0
      !re_email(oneselfData.email || ''), // 1
      (oneselfData.tel_number || '').length === 0, // 2
      editPsd && (oneselfData.old_passwd || '').length === 0, // 3 密碼為空
      editPsd && (oneselfData.passwd || '').length === 0, // 4 密碼為空
      editPsd && (oneselfData.passwd2 || '').length === 0, // 5 密碼為空
      (oneselfData.passwd || '') !== (oneselfData.passwd2 || ''), // 6 密碼不一樣
      editPsd && (oneselfData.passwd || '').length > 0 && !re_psd(oneselfData.passwd), // 7 密碼格式
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  render () {
    const { orgList = [], groupList = [], clearOneself, getOneself } = this.props;
    const { oneselfData = {}, old_oneselfData = {}, mode, canSend, errorAry } = this.state;
    const isCheck = mode === 'check';
    const isActChecking = oneselfData.user_check_log_id && oneselfData.user_check_log_id.length > 0;
    const checkChange = label => isCheck ? (oneselfData[label] || '') !== (old_oneselfData[label] || '') : false;
    const editPsd = ((oneselfData.old_passwd || '').length > 0) || ((oneselfData.passwd || '').length > 0) || ((oneselfData.passwd2 || '').length > 0);
    const allRight = errorAry.indexOf(true) === -1;

    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text={'個人資料維護管理'} text2={isActChecking ? '清查中' : ''} />
        <div style={{ height: 8 }} />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='使用者帳號' bol={false} />
              <EAA_Input displayBorder disabled hint='AA001' value={oneselfData.account || ''} onChange={data => { this.changeData({ label: 'account', data }); }} />
            </EAA_ItemContainer>
            {/* {errorAry[0] && <EAA_ErrorText text='帳號需包含 6 ~ 20 位英數字組合。' />} */}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='姓名' bol={true} haveChange={checkChange('user_name')} />
              <EAA_Input displayBorder disabled={isCheck} hint='AA001' value={oneselfData.user_name || ''} onChange={data => { this.changeData({ label: 'user_name', data }); }} />
            </EAA_ItemContainer>
            {errorAry[0] && <EAA_ErrorText text='請填寫姓名' />}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='單位名稱' bol={false} />
              <EAA_Select displayBorder disabled list={orgList} value={oneselfData.org_id || ''} onChange={data => { this.changeData({ label: 'org_id', data }); }} />
            </EAA_ItemContainer>
            {/* {errorAry[2] && <EAA_ErrorText text='請選擇組織單位。' />} */}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='電子信箱' bol={true} haveChange={checkChange('email')} />
              <EAA_Input displayBorder disabled={isCheck} hint='請填入Email' value={oneselfData.email || ''} onChange={data => { this.changeData({ label: 'email', data }); }} />
            </EAA_ItemContainer>
            {errorAry[1] && <EAA_ErrorText text='請輸入電子郵件。' />}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='聯絡電話' bol={true} haveChange={checkChange('tel_number')} />
              <EAA_Input displayBorder disabled={isCheck} hint='(02) 2655-1188#110' value={oneselfData.tel_number || ''} onChange={data => { this.changeData({ label: 'tel_number', data }); }} />
            </EAA_ItemContainer>
            {errorAry[2] && <EAA_ErrorText text='請填寫聯絡電話。' />}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='行動電話' haveChange={checkChange('mobile_number')} />
              <EAA_Input displayBorder disabled={isCheck} hint='09XX-XXX-XXX' value={oneselfData.mobile_number || ''} onChange={data => { this.changeData({ label: 'mobile_number', data }); }} />
            </EAA_ItemContainer>
            {/* {(oneselfData.mobile_number || '').length === 0 && <EAA_ErrorText text='請輸入行動電話。' />} */}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='權限' bol={false} />
              <EAA_Select displayBorder disabled list={groupList} value={oneselfData.group_id || ''} onChange={data => { this.changeData({ label: 'group_id', data }); }} />
            </EAA_ItemContainer>
            {/* {errorAry[5] && <EAA_ErrorText text='請選擇權限群。' />} */}
          </EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText text='註冊時間' />
            <div style={{ color: '#333333', fontSize: 18 }}>{oneselfData.add_time || ''}</div>
          </EAA_ItemContainer>
        </EAA_Row>
        <div style={{ marginTop: 32, display: 'flex', alignItems: 'center' }}>
          <div style={{ fontSize: 20, color: '#046860' }}>密碼修改</div>
          <div style={{ fontSize: 18, color: 'rgba(0, 0, 0, 0.54)', marginLeft: 5 }}>(如不修改登入密碼，則不需填寫以下欄位)</div>
        </div>
        <form style={{ width: '100%' }}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText text='舊密碼' bol={editPsd} />
                <EAA_Input displayBorder disabled={isCheck} type='password' hint='請輸入原登入密碼' value={oneselfData.old_passwd || ''} onChange={data => { this.changeData({ label: 'old_passwd', data }); }} />
              </EAA_ItemContainer>
              {errorAry[3] && <EAA_ErrorText text='請輸入' />}
              {/* {errorAry[7] && <EAA_ErrorText text='密碼需包含 12 ~ 20 位大小寫英文、數字、符號組合' />} */}
            </EAA_Item>
            <EAA_ItemContainer />
          </EAA_Row>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText text='新密碼' bol={editPsd} />
                <EAA_Input displayBorder disabled={isCheck} type='password' hint='請輸入新密碼' value={oneselfData.passwd || ''} onChange={data => { this.changeData({ label: 'passwd', data }); }} />
              </EAA_ItemContainer>
              {errorAry[4] && <EAA_ErrorText text='請輸入' />}
              {errorAry[7] && <EAA_ErrorText text='密碼長度12-20碼，須包含大小寫英文字元、數字字元及符號字元。' />}
            </EAA_Item>
            <EAA_ItemContainer />
          </EAA_Row>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText text='確認新密碼' bol={editPsd} />
                <EAA_Input displayBorder disabled={isCheck} type='password' hint='請輸入新密碼' value={oneselfData.passwd2 || ''} onChange={data => { this.changeData({ label: 'passwd2', data }); }} />
              </EAA_ItemContainer>
              {errorAry[5] && <EAA_ErrorText text='請輸入' />}
              {!errorAry[5] && errorAry[6] && <EAA_ErrorText text='新密碼不一致' />}
            </EAA_Item>
            <EAA_ItemContainer />
          </EAA_Row>
        </form>

        <div style={{ marginTop: 8, fontSize: 12, color: 'red' }}>※請勿使用與工研院內AD相同帳號名使用密碼</div>

        <div style={{ display: 'flex', marginTop: 36, width: '100%', justifyContent: 'center', marginBottom: 40 }}>
          {mode !== 'check' && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this.goBack} />}
          {mode !== 'check' && <EAA_Btn text={isActChecking ? '帳號確認並送出' : '確認'} backgroundColor={rightColor} style={{ marginLeft: 16 }} onClick={this.goToCheck} />}
          {mode === 'check' && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'check' && <EAA_Btn text={isActChecking ? '帳號確認並儲存' : '確認修改'} disabled={!allRight || !canSend} backgroundColor={(allRight && canSend) ? rightColor : 'gray'} style={{ marginLeft: 16 }} onClick={this.send} />}
        </div>

        <EditRes sucFunc={() => { clearOneself(); getOneself(); this.setState({ canSend: true, mode: '' }); }} failFunc={() => this.setState({ canSend: true })} resKey='Res_PutOneSelf' />
        <EditRes sucFunc={() => { clearOneself(); getOneself(); this.setState({ canSend: true, mode: '' }); }} failFunc={() => this.setState({ canSend: true })} resKey='Res_PutUserCheck' />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  orgList: state.data.OrgList,
  groupList: state.data.GroupList,
  oneself: state.data.Oneself,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  getOrgList: () => Actions.getOrgList(dispatch),
  getGroupList: () => Actions.getGroupList(dispatch),
  getOneself: () => Actions.getOneself(dispatch),
  clearOneself: () => Actions.clearOneself(dispatch),
  putOneSelf: body => Actions.putOneSelf(dispatch, { body }),
  putUserCheck: ({ body, id }) => Actions.putUserCheck(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Page_PersonalManagement));
